import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Button,
  Container,
  InputGroup,
  Image,
} from "@themesberg/react-bootstrap";
import { loginApi } from "../../app/api";
import { Routes } from "../../routes";
import { useHistory } from "react-router-dom";
import axios from "axios";
import ButtonLoader from "../../components/ButtonLoader";
import logo from "../../assets/img/vendor.png";
import swal from "sweetalert";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [Loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await axios.post(
        loginApi(),
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json", // Set Content-Type to application/json
            "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
          },
        }
      );
      setError(response.data.message);
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      swal({
              text: response.data.message,
              icon: "success",
            })
      history.push(Routes.DashboardOverview.path);
    } catch (err) {
      // setError("An error occurred. Please try again.");
      console.error("err",err)
      swal({
              text: err.response.data.messages.error,
              icon: "error",
            });
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
         

          <Row className="justify-content-center form-bg-image">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className=" mb-4 d-flex justify-content-center ">
                  <Image src={logo} className="logo_img  " />
                </div>

                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Sign in to our platform</h3>
                </div>
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Your Email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="email"
                        placeholder="example@company.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} // Update email state
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Your Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)} // Update password state
                        />
                      </InputGroup>
                    </Form.Group>
                  
                  </Form.Group>
                  {error && <div className="text-danger mb-3">{error}</div>}
                  {Loading ? (
                    <ButtonLoader />
                  ) : (
                    <Button variant="primary" type="submit" className="w-100">
                      Sign in
                    </Button>
                  )}
                </Form>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <p className="fw-normal">
                    Please login as admin only from this page.
                  </p>
                </div>
         
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
export default Signin;